export const model = {
    id: null,
    name: "",
    surname: "",
    patronymic: "",
    note: "",
    id_code: "",
    created_at: '',
    updated_at: ''
};